function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import simplyReactive from 'simply-reactive';
import { NEXT, PREV } from '../../direction';
import { getCurrentPageIndexByCurrentParticleIndex, getPartialPageSize, getPagesCountByParticlesCount, getParticleIndexByPageIndex } from '../../utils/page';
import { getClonesCount } from '../../utils/clones';
import { getAdjacentIndexes } from '../../utils/lazy';
import { getValueInRange } from '../../utils/math';
import { get, switcher } from '../../utils/object';
import { ProgressManager } from '../../utils/ProgressManager';

function createCarousel(onChange) {
  var progressManager = new ProgressManager({
    onProgressValueChange: function onProgressValueChange(value) {
      onChange('progressValue', 1 - value);
    }
  });
  var reactive = simplyReactive({
    data: {
      particlesCountWithoutClones: 0,
      particlesToShow: 1,
      // normalized
      particlesToShowInit: 1,
      // initial value
      particlesToScroll: 1,
      // normalized
      particlesToScrollInit: 1,
      // initial value
      particlesCount: 1,
      currentParticleIndex: 1,
      infinite: false,
      autoplayDuration: 1000,
      clonesCountHead: 0,
      clonesCountTail: 0,
      clonesCountTotal: 0,
      partialPageSize: 1,
      currentPageIndex: 1,
      pagesCount: 1,
      pauseOnFocus: false,
      focused: false,
      autoplay: false,
      autoplayDirection: 'next',
      disabled: false,
      // disable page change while animation is in progress
      durationMsInit: 1000,
      durationMs: 1000,
      offset: 0,
      particleWidth: 0,
      loaded: []
    },
    watch: {
      setLoaded: function setLoaded(_ref) {
        var data = _ref.data;
        data.loaded = getAdjacentIndexes({
          infinite: data.infinite,
          pageIndex: data.currentPageIndex,
          pagesCount: data.pagesCount,
          particlesCount: data.particlesCountWithoutClones,
          particlesToShow: data.particlesToShow,
          particlesToScroll: data.particlesToScroll
        }).particleIndexes;
      },
      setCurrentPageIndex: function setCurrentPageIndex(_ref2) {
        var data = _ref2.data;
        data.currentPageIndex = getCurrentPageIndexByCurrentParticleIndex({
          currentParticleIndex: data.currentParticleIndex,
          particlesCount: data.particlesCount,
          clonesCountHead: data.clonesCountHead,
          clonesCountTotal: data.clonesCountTotal,
          infinite: data.infinite,
          particlesToScroll: data.particlesToScroll
        });
      },
      setPartialPageSize: function setPartialPageSize(_ref3) {
        var data = _ref3.data;
        data.partialPageSize = getPartialPageSize({
          particlesToScroll: data.particlesToScroll,
          particlesToShow: data.particlesToShow,
          particlesCountWithoutClones: data.particlesCountWithoutClones
        });
      },
      setClonesCount: function setClonesCount(_ref4) {
        var data = _ref4.data;

        var _getClonesCount = getClonesCount({
          infinite: data.infinite,
          particlesToShow: data.particlesToShow,
          partialPageSize: data.partialPageSize
        }),
            head = _getClonesCount.head,
            tail = _getClonesCount.tail;

        data.clonesCountHead = head;
        data.clonesCountTail = tail;
        data.clonesCountTotal = head + tail;
      },
      setProgressManagerAutoplayDuration: function setProgressManagerAutoplayDuration(_ref5) {
        var data = _ref5.data;
        progressManager.setAutoplayDuration(data.autoplayDuration);
      },
      toggleProgressManager: function toggleProgressManager(_ref6) {
        var _ref6$data = _ref6.data,
            pauseOnFocus = _ref6$data.pauseOnFocus,
            focused = _ref6$data.focused;

        // as focused is in if block, it will not be put to deps, read them in data: {}
        if (pauseOnFocus) {
          if (focused) {
            progressManager.pause();
          } else {
            progressManager.resume();
          }
        }
      },
      initDuration: function initDuration(_ref7) {
        var data = _ref7.data;
        data.durationMs = data.durationMsInit;
      },
      applyAutoplay: function applyAutoplay(_ref8) {
        var data = _ref8.data,
            _applyAutoplayIfNeeded = _ref8.methods._applyAutoplayIfNeeded;
        // prevent _applyAutoplayIfNeeded to be called with watcher
        // to prevent its data added to deps
        data.autoplay && _applyAutoplayIfNeeded(data.autoplay);
      },
      setPagesCount: function setPagesCount(_ref9) {
        var data = _ref9.data;
        data.pagesCount = getPagesCountByParticlesCount({
          infinite: data.infinite,
          particlesCountWithoutClones: data.particlesCountWithoutClones,
          particlesToScroll: data.particlesToScroll,
          particlesToShow: data.particlesToShow
        });
      },
      setParticlesToShow: function setParticlesToShow(_ref10) {
        var data = _ref10.data;
        data.particlesToShow = getValueInRange(1, data.particlesToShowInit, data.particlesCountWithoutClones);
      },
      setParticlesToScroll: function setParticlesToScroll(_ref11) {
        var data = _ref11.data;
        data.particlesToScroll = getValueInRange(1, data.particlesToScrollInit, data.particlesCountWithoutClones);
      }
    },
    methods: {
      _prev: function _prev(_ref12) {
        var data = _ref12.data;
        data.currentParticleIndex = getParticleIndexByPageIndex({
          infinite: data.infinite,
          pageIndex: data.currentPageIndex - 1,
          clonesCountHead: data.clonesCountHead,
          clonesCountTail: data.clonesCountTail,
          particlesToScroll: data.particlesToScroll,
          particlesCount: data.particlesCount,
          particlesToShow: data.particlesToShow
        });
      },
      _next: function _next(_ref13) {
        var data = _ref13.data;
        data.currentParticleIndex = getParticleIndexByPageIndex({
          infinite: data.infinite,
          pageIndex: data.currentPageIndex + 1,
          clonesCountHead: data.clonesCountHead,
          clonesCountTail: data.clonesCountTail,
          particlesToScroll: data.particlesToScroll,
          particlesCount: data.particlesCount,
          particlesToShow: data.particlesToShow
        });
      },
      _moveToParticle: function _moveToParticle(_ref14, particleIndex) {
        var data = _ref14.data;
        data.currentParticleIndex = getValueInRange(0, particleIndex, data.particlesCount - 1);
      },
      toggleFocused: function toggleFocused(_ref15) {
        var data = _ref15.data;
        data.focused = !data.focused;
      },
      _applyAutoplayIfNeeded: function _applyAutoplayIfNeeded(_ref16) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var data, methods, onFinish;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  data = _ref16.data, methods = _ref16.methods;

                  if (!(!data.infinite && (data.autoplayDirection === NEXT && data.currentParticleIndex === data.particlesCount - 1 || data.autoplayDirection === PREV && data.currentParticleIndex === 0))) {
                    _context3.next = 4;
                    break;
                  }

                  progressManager.reset();
                  return _context3.abrupt("return");

                case 4:
                  if (!data.autoplay) {
                    _context3.next = 8;
                    break;
                  }

                  onFinish = function onFinish() {
                    var _switcher;

                    return switcher((_switcher = {}, _defineProperty(_switcher, NEXT, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              return _context.abrupt("return", methods.showNextPage());

                            case 1:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }))), _defineProperty(_switcher, PREV, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              return _context2.abrupt("return", methods.showPrevPage());

                            case 1:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }))), _switcher))(data.autoplayDirection);
                  };

                  _context3.next = 8;
                  return progressManager.start(onFinish);

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      // makes delayed jump to 1st or last element
      _jumpIfNeeded: function _jumpIfNeeded(_ref19) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var data, methods, jumped;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  data = _ref19.data, methods = _ref19.methods;
                  jumped = false;

                  if (!data.infinite) {
                    _context4.next = 13;
                    break;
                  }

                  if (!(data.currentParticleIndex === 0)) {
                    _context4.next = 9;
                    break;
                  }

                  _context4.next = 6;
                  return methods.showParticle(data.particlesCount - data.clonesCountTotal, {
                    animated: false
                  });

                case 6:
                  jumped = true;
                  _context4.next = 13;
                  break;

                case 9:
                  if (!(data.currentParticleIndex === data.particlesCount - data.clonesCountTail)) {
                    _context4.next = 13;
                    break;
                  }

                  _context4.next = 12;
                  return methods.showParticle(data.clonesCountHead, {
                    animated: false
                  });

                case 12:
                  jumped = true;

                case 13:
                  return _context4.abrupt("return", jumped);

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      changePage: function changePage(_ref20, updateStoreFn, options) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var data, methods, jumped;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  data = _ref20.data, methods = _ref20.methods;
                  progressManager.reset();

                  if (!data.disabled) {
                    _context5.next = 4;
                    break;
                  }

                  return _context5.abrupt("return");

                case 4:
                  data.disabled = true;
                  updateStoreFn();
                  _context5.next = 8;
                  return methods.offsetPage({
                    animated: get(options, 'animated', true)
                  });

                case 8:
                  data.disabled = false;
                  _context5.next = 11;
                  return methods._jumpIfNeeded();

                case 11:
                  jumped = _context5.sent;
                  !jumped && methods._applyAutoplayIfNeeded(); // no need to wait it finishes

                case 13:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      },
      showNextPage: function showNextPage(_ref21, options) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var data, methods;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  data = _ref21.data, methods = _ref21.methods;

                  if (!data.disabled) {
                    _context6.next = 3;
                    break;
                  }

                  return _context6.abrupt("return");

                case 3:
                  _context6.next = 5;
                  return methods.changePage(methods._next, options);

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      },
      showPrevPage: function showPrevPage(_ref22, options) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var data, methods;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  data = _ref22.data, methods = _ref22.methods;

                  if (!data.disabled) {
                    _context7.next = 3;
                    break;
                  }

                  return _context7.abrupt("return");

                case 3:
                  _context7.next = 5;
                  return methods.changePage(methods._prev, options);

                case 5:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }))();
      },
      showParticle: function showParticle(_ref23, particleIndex, options) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var methods;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  methods = _ref23.methods;
                  _context8.next = 3;
                  return methods.changePage(function () {
                    return methods._moveToParticle(particleIndex);
                  }, options);

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }))();
      },
      _getParticleIndexByPageIndex: function _getParticleIndexByPageIndex(_ref24, pageIndex) {
        var data = _ref24.data;
        return getParticleIndexByPageIndex({
          infinite: data.infinite,
          pageIndex: pageIndex,
          clonesCountHead: data.clonesCountHead,
          clonesCountTail: data.clonesCountTail,
          particlesToScroll: data.particlesToScroll,
          particlesCount: data.particlesCount,
          particlesToShow: data.particlesToShow
        });
      },
      showPage: function showPage(_ref25, pageIndex, options) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
          var methods, particleIndex;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  methods = _ref25.methods;
                  particleIndex = methods._getParticleIndexByPageIndex(pageIndex);
                  _context9.next = 4;
                  return methods.showParticle(particleIndex, options);

                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }))();
      },
      offsetPage: function offsetPage(_ref26, options) {
        var data = _ref26.data;
        var animated = get(options, 'animated', true);
        return new Promise(function (resolve) {
          // durationMs is an offset animation time
          data.durationMs = animated ? data.durationMsInit : 0;
          data.offset = -data.currentParticleIndex * data.particleWidth;
          setTimeout(function () {
            resolve();
          }, data.durationMs);
        });
      }
    }
  }, {
    onChange: onChange
  });

  var _reactive = _slicedToArray(reactive, 2),
      data = _reactive[0],
      methods = _reactive[1];

  return [{
    data: data,
    progressManager: progressManager
  }, methods, reactive._internal];
}

export default createCarousel;